import React from 'react';
import {Link} from "react-router-dom";

const Footer = ({handleMenuClick}) => {
  return (
    <footer>
      <div id="footer-area">
        <div id="footer-content">
          <img id="footer-logo" src="images/logo.png"/>
          
          <nav id="footer-links">
            <ul onClick={handleMenuClick}>
              <li><Link to="/" id="home">HOME</Link></li>
              <li><Link to="/portfolio" id="portfolio">PORTFOLIO</Link></li>
              <li><Link to="/contact" id="contact">CONTACT ME</Link></li>
            </ul>      
          </nav>
          
          <div id="social-icons">
            <img src="images/icons/github.png"/>
            <img src="images/icons/twitter.png"/>
            <img src="images/icons/linkedin.png"/>
            
          </div>
        </div>
      </div>
      
    </footer>
  );
}

export default Footer;